import ImageWidget from "QuorumGrassroots/widgets/Image/components/index"

export default ImageWidget
